import { Result, ok, err } from '@xlearn/common';

type ErrorCode = 'parse-error' | 'smaller-than-minimum' | 'larger-than-maximum'

export function parseReal(value: string, min?: number, max?: number): Result<number, ErrorCode> {

  if (typeof(value) !== 'string') {
    value = (value as any).toString();
  }

  const parsed = parseFloat(value.replace(',', '.'));

  if (isNaN(parsed)) {
    return err('parse-error');
  }

  const parsedNumber: number = parsed;

  if (min !== undefined && parsedNumber < min) {
    return err('smaller-than-minimum');
  }

  if (max !== undefined && parsedNumber > max) {
    return err('larger-than-maximum');
  }

  return ok(parsed);
}

export function realToString(value: number): string {

  const precision = 7;
  const factor = Math.pow(10, precision);

  const rounded = Math.round((value as number) * factor) / factor;

  return rounded.toString();
}
